import { render, staticRenderFns } from "./printErrorModal.vue?vue&type=template&id=118b4f6c&"
import script from "./printErrorModal.vue?vue&type=script&lang=ts&"
export * from "./printErrorModal.vue?vue&type=script&lang=ts&"
import style0 from "./printErrorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports